import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { PermissionService } from '@shared/services/permission.service';

/** `key` accepts a single permission, or an array to allow ANY one of several unrelated capabilities
 * (e.g. "own this record" OR "manage everyone's" — the two aren't a hierarchy, so a single-key guard
 * can't express it). */
export const permissionGuard =
  (key: string | string[]): CanActivateFn =>
  () => {
    const permissions = inject(PermissionService);
    const router = inject(Router);

    const check$ = Array.isArray(key) ? permissions.hasAnyWhenReady$(key) : permissions.hasWhenReady$(key);
    return check$.pipe(map((allowed) => (allowed ? true : router.createUrlTree(['/dashboard']))));
  };
